<div class="text-center root">
    <img class="ui medium image van-img" src={{leasing.picture}}>
    <h2>{{leasing.name}}</h2>
    <button class="ui button" (click)="details()">Détails</button>
    <button class="ui primary button" (click)="book()">Réserver</button>

    <leasing-details [leasing]="leasing"></leasing-details>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/leasing/leasing.html